import { Component, Input, ViewChildren, QueryList, ElementRef, Output, EventEmitter } from "@angular/core";
import { IFilter } from "@edp-models/benefits.model";

@Component({
    selector: "edp-contract-list-filter-content",
    templateUrl: "./edp-contract-list-filter-content.component.html"
})
export class EdpContractListFilterContentComponent {

    @Input() set filterInfo(filterInfo: IFilter) {
        this.tempFilterInfo = JSON.parse(JSON.stringify(filterInfo));
    }
    @Input() set filters(filters: IFilter[]) {
        if (this.tempFilterInfo.isMobileFilter) {
            this.tempFilters = JSON.parse(JSON.stringify(filters));
        } else {
            this.tempFilters = [this.tempFilterInfo];
        }
    }
    @Output() applyFilterChange = new EventEmitter<IFilter[]>();
    @ViewChildren("checkboxOpt") checkboxOpts!: QueryList<ElementRef>;
    public tempFilterInfo: IFilter;
    public tempFilters: IFilter[] = [];

    public openChange(open: boolean, filter: IFilter) {
        filter.clicked = false;
        if (!open) {
            this.updateCheckboxes(this.tempFilters);
        } else {
            filter.clicked = true;
        }
    }

    public applyFilter(filter: IFilter, filters: IFilter[]) {
        this.updateTempFilters(filters);
        filter.clicked = false;
        filter.hasOptionSelected = filter.isMobileFilter ? filters.some(flt => flt.hasOptionSelected) : filter.hasOptionSelected;
        this.applyFilterChange.emit(this.tempFilters);
    }

    public clearFilter() {
        this.checkboxOpts.toArray().forEach(chkEl => chkEl.nativeElement.checked = false);
    }

    public resetFilter() {
        this.clearFilter();
        this.applyFilter(this.tempFilterInfo, this.tempFilters);
    }

    private updateCheckboxes(base: IFilter[]) {
        if (this.checkboxOpts.toArray().length > 0) {
            base.forEach( (filter) => {
                this.checkboxOpts.toArray()
                    .filter(chkOpt => +chkOpt.nativeElement.getAttribute("filter") === filter.id)
                    .forEach(chkEl => {
                        filter.options.forEach((filterOption) => {
                            if (+chkEl.nativeElement.getAttribute("option") === filterOption.id) {
                                chkEl.nativeElement.checked = filterOption.selected;
                            }
                        });
                    });
            });
        }
    }

    private updateTempFilters(filters: IFilter[]) {
        filters.forEach(filter => {
            if (this.checkboxOpts) {
                const tempFilter = this.tempFilters.find( flt => flt.id === filter.id );
                this.checkboxOpts.toArray().filter( cb => +cb.nativeElement.getAttribute("filter") === filter.id).forEach(
                    opt => {
                        const optionId = opt.nativeElement.getAttribute("option");
                        tempFilter.options.find( tempOpt => tempOpt.id === +optionId ).selected = opt.nativeElement.checked;
                    }
                );
                tempFilter.hasOptionSelected = tempFilter.options.some(opt => opt.selected);
            }
        });
    }
}
